import { ContentState, EditorState, convertFromHTML } from 'draft-js'
import { ComponentFields } from './componentEditState'

export const htmlStringToEditorState = (htmlString: string): EditorState => {
  const blocksFromHTML = convertFromHTML(htmlString)
  return EditorState.createWithContent(
    ContentState.createFromBlockArray(
      blocksFromHTML.contentBlocks,
      blocksFromHTML.entityMap
    )
  )
}

export const isDraft = (componentFields: ComponentFields) =>
  componentFields.name === '' ||
  componentFields.mainIngredients.length < 1 ||
  componentFields.ingredients.some((ingr) => ingr.ingredient.id === 0) ||
  !componentFields.preparation.getCurrentContent().hasText()
